import React from 'react';
import $ from 'jquery';
import si from 'si';
import ProductSlider from './ProductSlides';
import ProductDetailInfo from './ProductDetailInfo';
import RelatedProducts from './RelatedProducts';
import CartActions from '../Cart/CartActions';
import { Helmet } from 'react-helmet';

export default class ProductDetail extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			ProductData: []
		}
	}
	
	componentWillMount() {
		this.getProduct();
	}
	
	addToCart(qty) {
		// ProductID defined in Product Details code-in-front
		let cartCode = CartActions.getCart().code;
		CartActions.addItemToCart(cartCode, productID, qty);
	}
	
	getProduct() {
		si.getProductDetails({}, productID).then((data) => {
			this.setState({
				ProductData: data
			})
		});
	}
	


	render() {

		let imageCode = (this.state.ProductData && this.state.ProductData.imageGallery && this.state.ProductData.imageGallery.length > 0)? this.state.ProductData.imageGallery[0].imageResourceKey : null;
		let imageURL = imageCode != null ? window.jenkon.consultantRoot + 'Image/GetImage?code=' + imageCode: null;
		
		return (

			<div id="product-details-section-wrapper">
				{imageURL != null ?
				<Helmet async meta={[
					{ property: "og:title", content: this.state.ProductData && this.state.ProductData.name },
					{ property: "og:description", content: this.state.ProductData && this.state.ProductData.description },
					{ property: "og:image", content: `${imageURL}` },
					{ property: "og:url", content: `${window.jenkon.consultantRoot}ProductDetails?ID=${this.state.ProductData && this.state.ProductData.offerCode}` },
					]} 
					/>
					: null }
				<ul id="breadcrumbs-area" className="breadcrumbs-wrapper clearfix">
					<li className="breadcrumb-item">
						<a href={window.jenkon.consultantRoot + 'Products'}>&laquo; {this.props.resources["PWS.ProductDetails.BackToProductsLink"]}</a>
					</li>
				</ul>
				<div className="site-container clearfix" style={{padding: '12px 0 12px 0'}}>
					{/*<ProductSlider imageGallery={this.state.ProductData.imageGallery} />*/}
					
					<div className="product clearfix">
						<div className="product-details-image clearfix">
							<div className="details-image">
								{imageURL != null ? <img src={imageURL} alt="" /> : null}
							</div>
						</div>
					</div>
					
					<div className="product-details-area-wrapper clearfix">
						<ProductDetailInfo resources={this.props.resources} addToCart={this.addToCart.bind(this)} ProductData={this.state.ProductData} />
					</div>
					{/*<div style={{clear: 'both'}}></div>
					<div className="horiz-text-divider">
						<span className="horiz-text-divider-content">{this.props.resources["PWS.ProductDetails.SimilarProductsTitle"]}</span>
					</div>*}
						{/*<RelatedProducts resources={this.props.resources} RelatedProducts={this.state.ProductData.relatedProducts} />*/}


                    <div style={{clear: 'both'}}></div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductDetail/ProductDetailContainer.js